type ClientConfigs = {
  IFRAMELY_KEY: string
  CHARGEBEE_SITE: string
  AUTH_URL: string
  CREATOR_APP_BASE_URL: string
  CREATOR_APP_V2_BASE_URL?: string
  PUBLIC_APP_BASE_URL: string
  FACEBOOK_APP_ID?: string
}

export let clientConfig: ClientConfigs | undefined

export function initConfig(configs: ClientConfigs) {
  if (!clientConfig) {
    clientConfig = {
      ...configs,
    }
  }

  return clientConfig
}
